import ScrollToElement from '~utilities/scroll-to-element';

class ScrollToLink {
    constructor(element, attribute) {
        this.element = element;

	    this.element.addEventListener('click', (event) => {
        event.preventDefault();

        console.log(this.element, this.element.getAttribute('href'));
        const id = this.element.getAttribute('href');
        const offset = this.element.getAttribute(attribute);
        const linkTo = document.querySelector(`${id}`);
        console.log(id, linkTo);
        new ScrollToElement(linkTo, offset, id);
      }, {passive: true})
    }
}

export default ScrollToLink;